import { inject, provide, ref, type Ref } from 'vue'

const EXPORT_PDF_LIGHT_THEME_KEY = Symbol('EXPORT_PDF_LIGHT_THEME_KEY')

export const provideExportPdfLightTheme = (): Ref<boolean> => {
    const isPdfLightTheme = ref(false)
    provide(EXPORT_PDF_LIGHT_THEME_KEY, isPdfLightTheme)

    return isPdfLightTheme
}

export const useExportPdfLightTheme = (): Ref<boolean> => {
    return inject(EXPORT_PDF_LIGHT_THEME_KEY, ref(false))
}
